import React from 'react';

const ForBrands = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={93}
      height={61}
      viewBox='0 0 93 61'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_25_262)'>
        <path
          d='M63.8747 40.3273H82.3595L82.3595 7.19829H63.8747L63.8747 40.3273Z'
          fill='#F7F0ED'
        />
        <path
          opacity='0.27'
          d='M12.6405 42.2415H82.8083L81.2103 39.2962L12.6405 36.1769L12.6405 42.2415Z'
          fill='#FF5612'
        />
        <path
          d='M12.6405 41.0363H81.2103L81.2103 38.0911L12.6405 40.2888L12.6405 41.0363Z'
          fill='#FF5612'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.6404 40.3274L81.2103 40.3274L81.2103 7.33106L12.6404 7.33106L12.6404 40.3274Z'
          fill='#FF5612'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.9598 4.0123L15.9598 37.3946C15.9598 37.3946 25.6209 37.2036 37.9596 35.0636C39.6853 34.7644 41.4608 34.8899 43.1061 35.49C45.2341 36.2657 46.9253 37.3946 46.9253 37.3946L47.1169 37.4274L47.1169 4.04506L46.9253 4.0122C46.9253 4.0122 45.2341 2.88339 43.1061 2.10763C41.4608 1.50755 39.6853 1.38207 37.9596 1.6812C25.6209 3.82121 15.9598 4.0123 15.9598 4.0123Z'
          fill='white'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.9598 37.3144L14.508 38.8474H47.1169L47.1169 37.3473L46.9253 37.3144C46.9253 37.3144 45.2341 36.1856 43.1061 35.4099C41.4608 34.8098 39.6853 34.6843 37.9596 34.9834C25.6209 37.1233 15.9598 37.3144 15.9598 37.3144Z'
          fill='#F7F0ED'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M78.2737 4.01198L78.2737 37.3945C78.2737 37.3945 77.0524 37.3701 74.9244 37.2435C71.0663 37.0117 64.2263 36.4428 56.2738 35.0636C54.549 34.7647 52.7725 34.8902 51.1279 35.49C48.9999 36.2652 47.3089 37.3945 47.3089 37.3945L47.1168 37.4275L47.1168 4.04495L47.3089 4.01198C47.3089 4.01198 48.9999 2.8837 51.1279 2.10741C52.7725 1.50765 54.549 1.38217 56.2738 1.68099C68.6132 3.82163 78.2737 4.01198 78.2737 4.01198Z'
          fill='white'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M78.2741 37.3144L79.7259 38.8474H47.1169L47.1169 37.3473L47.3085 37.3144C47.3085 37.3144 48.9998 36.1856 51.1277 35.4099C52.773 34.8098 54.5486 34.6843 56.2743 34.9834C68.613 37.1233 78.2741 37.3144 78.2741 37.3144Z'
          fill='#F7F0ED'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          opacity='0.16'
          d='M15.9598 37.3144L14.508 38.8474H47.1169L47.1169 37.3473L46.9253 37.3144C46.9253 37.3144 45.2341 36.1856 43.1061 35.4099C41.4608 34.8098 39.6853 34.6843 37.9596 34.9834C25.6209 37.1233 15.9598 37.3144 15.9598 37.3144Z'
          fill='#FF5612'
        />
        <path
          opacity='0.16'
          d='M78.2741 37.3144L79.7259 38.8474H47.1169L47.1169 37.3473L47.3085 37.3144C47.3085 37.3144 48.9998 36.1856 51.1277 35.4099C52.773 34.8098 54.5486 34.6843 56.2743 34.9834C68.613 37.1233 78.2741 37.3144 78.2741 37.3144Z'
          fill='#FF5612'
        />
        <path
          d='M78.2741 4.01233L79.7259 7.33102L79.7259 38.8474L78.2741 37.3145L78.2741 4.01233Z'
          fill='#F7F0ED'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.9598 4.01233L14.508 7.33102L14.508 38.8474L15.9598 37.3145L15.9598 4.01233Z'
          fill='#F7F0ED'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M45.1537 38.8474H49.0801C49.0801 38.0631 48.4491 37.4274 47.6707 37.4274H46.5632C45.7847 37.4273 45.1537 38.0631 45.1537 38.8474Z'
          fill='#FF5612'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          opacity='0.1'
          d='M45.1537 3.0025L47.1169 4.04507L47.1169 37.4273L45.1537 36.3047'
          fill='#FF5612'
        />
        <path
          opacity='0.1'
          d='M49.0801 3.0025L47.1169 4.04507L47.1169 37.4273L49.0801 36.3047'
          fill='#FF5612'
        />
        <path
          d='M70.6126 6.50708L70.6126 10.3528C72.1564 10.4898 73.5202 10.5901 74.6597 10.6634L74.6597 6.8177C73.5201 6.74443 72.1564 6.64607 70.6126 6.50708Z'
          fill='#FF5612'
        />
        <path
          d='M74.1075 7.58767C72.9678 7.5143 72.9085 7.53578 71.3647 7.39679'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 8.45724C72.9678 8.38387 72.9085 8.40535 71.3647 8.26636'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.9083 6.1366L66.9083 9.98231C68.2318 10.129 69.4729 10.2505 70.6125 10.3528L70.6125 6.50709C69.4729 6.40479 68.2318 6.28324 66.9083 6.1366Z'
          fill='#FF5612'
        />
        <path
          d='M63.1427 5.67737L63.1427 9.525C64.4585 9.69865 65.717 9.85115 66.9083 9.98227L66.9083 6.13655C65.717 6.00532 64.4585 5.85294 63.1427 5.67737Z'
          fill='#FF5612'
        />
        <path
          d='M66.3163 6.93953C65.125 6.80831 65.1906 6.81937 63.8747 6.6438'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M59.4384 5.14471L59.4384 8.99043C60.7141 9.18918 61.9514 9.36666 63.1427 9.5249L63.1427 5.67727C61.9514 5.51914 60.7141 5.34347 59.4384 5.14471Z'
          fill='#FF5612'
        />
        <path
          d='M62.536 6.55576C61.3447 6.39753 61.3678 6.40487 60.0921 6.20612'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M55.7361 4.56195L55.7361 8.40767C56.0081 8.43276 56.28 8.46945 56.552 8.51762C57.5326 8.68745 58.4961 8.84569 59.4384 8.99042L59.4384 5.1447C58.496 4.99997 57.5326 4.84173 56.552 4.67191C56.28 4.62373 56.008 4.58705 55.7361 4.56195Z'
          fill='#FF5612'
        />
        <path
          d='M58.8458 6.06935C57.9034 5.92462 56.8239 5.71406 56.5519 5.68896'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M58.8458 6.96644C57.9034 6.82171 56.8239 6.61116 56.5519 6.58606'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M52.183 4.85336L52.183 8.69908C53.338 8.38654 54.5427 8.29583 55.736 8.4077L55.736 4.56199C54.5427 4.45012 53.3379 4.54083 52.183 4.85336Z'
          fill='#FF5612'
        />
        <path
          d='M55.2412 5.55469C54.0479 5.44282 53.7558 5.50322 52.5545 5.74972'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.1'
          d='M52.183 8.69908L52.183 32.3851C53.6023 32.0011 55.0944 31.9509 56.552 32.2036C63.769 33.454 70.0725 34.0406 74.0603 34.3108H74.6598L74.6598 10.6634C73.5202 10.5901 72.1565 10.4898 70.6127 10.3528C69.473 10.2505 68.2319 10.1289 66.9085 9.9823C65.7171 9.85108 64.4587 9.69869 63.1429 9.52504C61.9516 9.3668 60.7143 9.18932 59.4386 8.99057C58.4962 8.84584 57.5328 8.6876 56.5522 8.51777C56.2802 8.4695 56.0083 8.43292 55.7363 8.40782C54.5427 8.29584 53.3379 8.38655 52.183 8.69908Z'
          fill='#FF5612'
        />
        <path
          opacity='0.27'
          d='M19.9737 7.82749C21.1134 7.75422 22.4771 7.65384 24.0208 7.51687C25.1605 7.41457 26.4016 7.29302 27.7251 7.14638C28.9164 7.01515 30.1748 6.86277 31.4907 6.68911C32.682 6.53088 33.9193 6.35339 35.1949 6.15464C36.1373 6.00991 37.1007 5.85168 38.0814 5.68185C38.3534 5.63357 38.6253 5.59699 38.8973 5.57189C40.0906 5.46002 41.2953 5.55062 42.4503 5.86327'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M19.9737 9.2263C21.1134 9.15303 22.4771 9.05264 24.0208 8.91568C25.1605 8.81338 26.4016 8.69183 27.7251 8.54518C28.9164 8.41396 30.1748 8.26157 31.4907 8.08792C32.682 7.92968 33.9193 7.7522 35.1949 7.55345C36.1373 7.40872 37.1011 7.2525 38.0814 7.08065C38.3534 7.03301 38.6253 6.99579 38.8973 6.9707C40.0906 6.85883 41.2953 6.94943 42.4503 7.26207'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M19.9737 10.6759C21.1134 10.6026 22.4771 10.5022 24.0208 10.3652C25.1605 10.2629 26.4016 10.1414 27.7251 9.99475C28.9164 9.86353 30.1748 9.71114 31.4907 9.53748C32.682 9.37925 33.9193 9.20176 35.1949 9.00301C36.1373 8.85828 37.1011 8.70207 38.0814 8.53022C38.3534 8.48258 38.6253 8.44536 38.8973 8.42027C40.0906 8.30839 41.2953 8.3991 42.4503 8.71164'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M35.6991 22.3753C36.4801 22.2524 37.2749 22.1206 38.0815 21.9809C38.3535 21.9326 38.6254 21.8959 38.8974 21.8709C40.0907 21.759 41.2954 21.8496 42.4504 22.1623'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M19.9737 24.1266C21.1134 24.0533 22.4771 23.9529 24.0208 23.816C24.6659 23.7581 25.3433 23.694 26.0499 23.6227'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M35.6992 23.7742C36.4803 23.6517 37.2753 23.521 38.0815 23.3797C38.3535 23.332 38.6254 23.2948 38.8974 23.2697C40.0907 23.1578 41.2954 23.2484 42.4504 23.5611'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M19.9737 25.5254C21.1134 25.4521 22.4771 25.3517 24.0208 25.2148C24.7027 25.1536 25.4209 25.0855 26.1713 25.0092'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M35.6992 25.2237C36.4803 25.1012 37.2753 24.9705 38.0815 24.8292C38.3535 24.7815 38.6254 24.7443 38.8974 24.7192C40.0907 24.6073 41.2954 24.6981 42.4504 25.0106'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M40.3488 28.0558C41.0584 28.0888 41.7632 28.1962 42.4504 28.3821'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M35.6991 28.5952C36.4801 28.4722 37.2749 28.3405 38.0815 28.2007'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M40.1898 29.4484C40.953 29.4719 41.7119 29.581 42.4503 29.781'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M35.6992 29.9941C36.4803 29.8716 37.2753 29.7409 38.0815 29.5995'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.1'
          d='M40.1898 30.8979C40.953 30.9215 41.7119 31.0306 42.4503 31.2305'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M35.6992 31.4436C36.4803 31.3211 37.2753 31.1904 38.0815 31.0491'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M19.9737 26.9749C21.1134 26.9017 22.4771 26.8013 24.0208 26.6643C24.7027 26.6031 25.4209 26.535 26.1714 26.4587'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M37.506 14.6726C37.6971 14.6401 37.8889 14.6073 38.0815 14.5739C38.3535 14.5256 38.6254 14.489 38.8974 14.4639C40.0907 14.3521 41.2954 14.4427 42.4504 14.7553'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M37.506 13.3689C37.6971 13.3365 37.8889 13.3036 38.0815 13.2702C38.3535 13.222 38.6254 13.1854 38.8974 13.1603C40.0907 13.0484 41.2954 13.139 42.4504 13.4516'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M37.5115 16.0712C37.7008 16.0389 37.8908 16.0061 38.0815 15.9727C38.3535 15.925 38.6254 15.8878 38.8974 15.8627C40.0907 15.7509 41.2954 15.8415 42.4504 16.1541'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M37.5115 17.5207C37.7008 17.4884 37.8908 17.4556 38.0815 17.4222C38.3535 17.3744 38.6254 17.3373 38.8974 17.3122C40.0907 17.2004 41.2954 17.2911 42.4504 17.6036'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M37.5056 18.8492C37.6968 18.8167 37.8888 18.7835 38.0815 18.7497C38.3535 18.702 38.6254 18.6648 38.8974 18.6397C40.0907 18.5278 41.2954 18.6184 42.4504 18.9311'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M70.6126 34.4988L70.6126 10.3528'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M70.6126 10.9973L70.6126 6.09222'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M69.8924 7.31992C69.2837 7.29153 68.5051 7.19838 67.662 7.07672'
          stroke='#F7F0ED'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.3163 12.2915C65.125 12.1602 65.1906 12.1713 63.8747 11.9957'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M62.536 11.9077C61.3447 11.7495 61.3678 11.7568 60.0921 11.558'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M58.8458 11.4213C57.9034 11.2765 56.8239 11.066 56.5519 11.0409Z'
          fill='#F7F0ED'
        />
        <path
          d='M58.8458 11.4213C57.9034 11.2765 56.8239 11.066 56.5519 11.0409'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M55.2412 10.9066C54.0479 10.7947 53.7558 10.8552 52.5545 11.1017Z'
          fill='#F7F0ED'
        />
        <path
          d='M55.2412 10.9066C54.0479 10.7947 53.7558 10.8552 52.5545 11.1017'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M69.8924 12.6719C69.2837 12.6435 68.5051 12.5503 67.662 12.4286'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.3163 15.8964C65.125 15.7652 65.1906 15.7763 63.8747 15.6007Z'
          fill='#F7F0ED'
        />
        <path
          d='M66.3163 15.8964C65.125 15.7652 65.1906 15.7763 63.8747 15.6007'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M62.536 15.5127C61.3447 15.3544 61.3678 15.3618 60.0921 15.163Z'
          fill='#F7F0ED'
        />
        <path
          d='M62.536 15.5127C61.3447 15.3544 61.3678 15.3618 60.0921 15.163'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M58.8458 15.0263C57.9034 14.8815 56.8239 14.671 56.5519 14.6459'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M69.8924 16.2768C69.2837 16.2484 68.5051 16.1553 67.662 16.0336'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.3163 22.1221C65.125 21.9909 65.1906 22.0019 63.8747 21.8264'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M58.8458 21.2519C57.9034 21.1072 56.8239 20.8966 56.5519 20.8715'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M55.2412 20.7372C54.0479 20.6253 53.7558 20.6857 52.5545 20.9322Z'
          fill='#F7F0ED'
        />
        <path
          d='M55.2412 20.7372C54.0479 20.6253 53.7558 20.6857 52.5545 20.9322'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M69.8924 22.5025C69.2837 22.4741 68.5051 22.3809 67.662 22.2593'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M62.536 18.5004C61.3447 18.3422 61.3678 18.3495 60.0921 18.1508'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M58.8458 18.014C57.9034 17.8693 56.8239 17.6587 56.5519 17.6336'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M55.2412 17.4993C54.0479 17.3875 53.7558 17.4479 52.5545 17.6944Z'
          fill='#F7F0ED'
        />
        <path
          d='M55.2412 17.4993C54.0479 17.3875 53.7558 17.4479 52.5545 17.6944'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M69.8924 19.2646C69.2837 19.2362 68.5051 19.143 67.662 19.0214Z'
          fill='#F7F0ED'
        />
        <path
          d='M69.8924 19.2646C69.2837 19.2362 68.5051 19.143 67.662 19.0214'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M66.3163 25.8389C65.125 25.7077 65.1906 25.7187 63.8747 25.5432'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M58.8458 24.9686C57.9034 24.8238 56.8239 24.6133 56.5519 24.5882'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M55.2412 24.454C54.0479 24.3422 53.7558 24.4026 52.5545 24.6491Z'
          fill='#F7F0ED'
        />
        <path
          d='M55.2412 24.454C54.0479 24.3422 53.7558 24.4026 52.5545 24.6491'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M69.8924 26.2192C69.2837 26.1908 68.5051 26.0976 67.662 25.976'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.9083 33.9837L66.9083 9.9823'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.9083 10.8526L66.9083 5.57892'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M63.1427 33.8119L63.1427 9.52502'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M63.1427 9.98227L63.1427 5.19299'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M59.4384 33.2473L59.4384 8.99042'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 12.4844C72.9678 12.411 72.9085 12.4325 71.3647 12.2935'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 13.3539C72.9678 13.2806 72.9085 13.302 71.3647 13.163'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 15.9652C72.9678 15.8919 72.9085 15.9133 71.3647 15.7744'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 16.8348C72.9678 16.7615 72.9085 16.7829 71.3647 16.6439'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 18.9949C72.9678 18.9215 72.9085 18.943 71.3647 18.804'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 19.8645C72.9678 19.7911 72.9085 19.8126 71.3647 19.6736'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 22.4757C72.9678 22.4024 72.9085 22.4238 71.3647 22.2849'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 23.3453C72.9678 23.2719 72.9085 23.2934 71.3647 23.1544'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 25.9489C72.9678 25.8756 72.9085 25.897 71.3647 25.758'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M74.1075 26.8184C72.9678 26.7451 72.9085 26.7665 71.3647 26.6275'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M59.4384 9.21241L59.4384 4.51575'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M55.7361 32.426L55.7361 8.40771'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M55.7361 8.73001L55.7361 4.01208'
          stroke='white'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.6649 18.9852C25.0972 19.0413 24.547 19.0931 24.0208 19.1404C22.4771 19.2773 21.1133 19.3777 19.9737 19.451'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M25.6649 14.7736C25.0972 14.8297 24.547 14.8814 24.0208 14.9288C22.4771 15.0657 21.1133 15.1661 19.9737 15.2394'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.6649 16.1723C25.0972 16.2283 24.547 16.2802 24.0208 16.3275C22.4771 16.4644 21.1133 16.5648 19.9737 16.6381'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.6649 17.6218C25.0972 17.6779 24.547 17.7297 24.0208 17.777C22.4771 17.9139 21.1133 18.0143 19.9737 18.0876'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.6649 20.4348C25.0972 20.4908 24.547 20.5426 24.0208 20.5899C22.4771 20.7269 21.1133 20.8273 19.9737 20.9005'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M34.6412 17.8627C33.5613 18.0272 32.5084 18.1773 31.4908 18.3125C30.6167 18.4279 29.7706 18.5329 28.9501 18.6296'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M34.6412 16.4993C33.5613 16.6638 32.5084 16.814 31.4908 16.9492C30.6167 17.0645 29.7706 17.1696 28.9501 17.2663'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M34.6412 13.6511C33.5613 13.8156 32.5084 13.9657 31.4908 14.1009C30.6167 14.2163 29.7706 14.3213 28.9501 14.418'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M34.6412 19.3123C33.5613 19.4768 32.5084 19.6269 31.4908 19.7621C30.6167 19.8775 29.7706 19.9825 28.9501 20.0792'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M34.6412 15.0497C33.5613 15.2143 32.5084 15.3644 31.4908 15.4996C30.6167 15.6149 29.7706 15.72 28.9501 15.8167'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.1392 31.3321C24.5715 31.3881 24.0214 31.4399 23.4952 31.4872C21.9514 31.6242 20.5876 31.7246 19.4481 31.7979'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.1392 29.9687C24.5715 30.0247 24.0214 30.0765 23.4952 30.1238C21.9514 30.2608 20.5876 30.3612 19.4481 30.4345'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M25.1392 32.7816C24.5715 32.8377 24.0214 32.8894 23.4952 32.9368C21.9514 33.0737 20.5876 33.1741 19.4481 33.2474'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M30.3168 30.7438C29.6708 30.8266 29.0403 30.9039 28.4242 30.9766'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M34.1154 30.2095C33.4688 30.308 32.8319 30.4014 32.2065 30.4895'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M30.1698 29.3991C29.5751 29.4749 28.9935 29.5461 28.4242 29.6131'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M34.1154 28.8461C33.4688 28.9446 32.8319 29.038 32.2065 29.1261'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M30.4004 32.1826C29.7253 32.2695 29.0669 32.3504 28.4242 32.4261'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M34.1154 31.6591C33.4688 31.7575 32.8319 31.8509 32.2065 31.9391'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.1'
          d='M27.6282 23.4163L27.6282 26.276C28.245 26.2142 28.8847 26.1467 29.5435 26.0734C30.7348 25.9422 31.9932 25.7898 33.3091 25.616C33.5753 25.5812 33.8435 25.5447 34.1154 25.508L34.1154 22.6483C33.8434 22.6849 33.5753 22.7215 33.3091 22.7563C31.9932 22.93 30.7348 23.0824 29.5435 23.2137C28.8846 23.2869 28.2449 23.3545 27.6282 23.4163Z'
          fill='#FF5612'
        />
        <path
          d='M43.6935 15.0394L44.5793 14.1616L45.4651 15.4648L45.4651 3.14859L43.6935 2.35443L43.6935 15.0394Z'
          fill='#FFD671'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          opacity='0.27'
          d='M95 53.434L95 43.7899L80.9907 31.8904L79.0263 30.2219L78.2737 31.3533L78.2737 35.172L78.2737 37.3946C78.2737 37.3946 77.7417 37.3839 76.7695 37.3403C76.267 37.318 75.6485 37.2861 74.9244 37.2436C74.785 37.2351 74.6415 37.2265 74.4937 37.217L75.0848 38.8706L76.7737 40.3594C76.7737 40.3594 89.4625 54.7888 95 60.9842L95 53.434Z'
          fill='#FF5612'
        />
        <path
          opacity='0.27'
          d='M19.9738 12.1648C21.1134 12.0915 22.4771 11.9911 24.0209 11.8542C25.1605 11.7519 26.4017 11.6303 27.7251 11.4837C28.9164 11.3525 30.1749 11.2001 31.4907 11.0263'
          stroke='#FF5612'
          strokeWidth='4.306'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.27'
          d='M78.2737 25.6343L78.2737 37.3946C78.2737 37.3946 77.0524 37.3701 74.9244 37.2436C74.4135 37.067 74.1 36.9565 74.1 36.9565C74.1 36.9565 69.7932 35.956 66.6407 33.9438C62.0314 31.0017 58.4074 26.819 53.6222 24.6567C53.4407 24.5746 53.5272 24.5486 53.5272 24.5486L58.1432 23.5256L73.4667 21.4307L78.2737 25.6343Z'
          fill='#FF5612'
        />
        <path
          d='M54.0119 24.6476L53.4295 24.5577C53.3468 24.5449 53.3238 24.4348 53.395 24.3898L53.8493 24.1C53.7899 24.1689 53.7684 24.2863 53.8021 24.4044C53.8349 24.5203 53.9275 24.6189 54.0119 24.6476Z'
          fill='#FF5612'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M57.758 25.227L54.0119 24.6476C53.9275 24.619 53.8349 24.5203 53.802 24.4044C53.7684 24.2864 53.7899 24.169 53.8492 24.1001C53.8495 24.0996 53.8495 24.0996 53.8497 24.0993L56.9706 22.1081L57.758 25.227Z'
          fill='#B1C9C7'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M65.9186 21.3975L63.8584 25.8245'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M62.8978 27.2075C62.2416 26.7461 61.9903 25.8628 62.3415 25.1079L64.4018 20.681C64.7946 19.8369 65.7922 19.4737 66.6298 19.8693C67.4672 20.2649 67.8283 21.2698 67.4356 22.1139L65.3753 26.5409C64.9825 27.3849 63.9849 27.7482 63.1473 27.3526C63.0587 27.3107 62.9754 27.2621 62.8978 27.2075Z'
          fill='#EDB19B'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M66.5878 20.9357L66.2117 26.318'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M65.2541 27.7032C64.7867 27.3746 64.4976 26.814 64.5406 26.1994L64.9167 20.8171C64.9817 19.8874 65.7826 19.1866 66.7056 19.252C67.6287 19.3175 68.3242 20.1243 68.2592 21.0542L67.8831 26.4367C67.8181 27.3664 67.0171 28.0672 66.0943 28.0018C65.781 27.9795 65.4941 27.8719 65.2541 27.7032Z'
          fill='#EDB19B'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M65.4549 22.8779L68.6162 26.7629'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M67.8624 27.8525C67.739 27.7657 67.6252 27.6607 67.5251 27.5376L64.3638 23.6525C63.7772 22.9316 63.8818 21.8682 64.5974 21.2772C65.313 20.6863 66.3686 20.7914 66.9552 21.5125L70.1165 25.3976C70.703 26.1185 70.5984 27.1819 69.8829 27.7729C69.2895 28.263 68.4622 28.2742 67.8624 27.8525Z'
          fill='#EDB19B'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M65.3066 18.9086C65.2082 18.9705 65.1935 23.1706 65.1935 23.1706L71.2203 25.8463C71.2203 25.8463 73.6295 23.2708 73.5941 23.1619C73.5585 23.0531 72.1889 18.8766 72.0972 18.7561C72.0055 18.6356 65.3066 18.9086 65.3066 18.9086Z'
          fill='#EDB19B'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M59.9566 24.2074C59.8224 24.113 59.6999 23.9972 59.5939 23.8603C59.0251 23.1251 59.1555 22.0647 59.8852 21.4916L64.8234 17.6133C65.4565 17.116 66.247 16.8668 67.0491 16.9118L72.759 17.2332C73.7504 17.2891 74.6567 17.7827 75.2458 18.5878L79.225 26.274C79.7741 27.0243 80.5046 27.0492 79.7598 27.6023C79.015 28.1554 77.9664 27.9956 77.4172 27.2451L72.5573 20.6028L66.8741 20.2829L61.9451 24.1539C61.3513 24.6202 60.5433 24.6199 59.9566 24.2074Z'
          fill='#FCD3B6'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M79.1862 31.6768L82.5958 28.597L76.4943 20.2271L73.4956 18.5099L71.1353 22.7418'
          fill='#FCD3B6'
        />
        <path
          d='M79.1862 31.6768L82.5958 28.597L76.4943 20.2271L73.4956 18.5099L71.1353 22.7418'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <g opacity='0.83'>
          <path
            d='M71.1317 22.7603C71.1364 22.7603 71.1411 22.7603 71.1459 22.7603L71.1378 22.7521C71.1358 22.7549 71.1336 22.7574 71.1317 22.7603Z'
            fill='#EAAA96'
          />
          <path
            d='M76.4943 20.2272L75.0071 19.3755L71.6129 21.8852L71.1351 22.7419L71.1521 22.7607C75.129 22.0336 77.7943 22.459 79.6952 24.6181L76.4943 20.2272Z'
            fill='#EAAA96'
          />
        </g>
        <path
          d='M57.2576 21.9996C64.2927 20.4436 77.3451 17.4881 78.7635 17.0649C79.5582 16.6957 80.7116 20.0164 79.6414 20.2875C79.102 20.4242 78.3178 20.6135 77.3106 20.8503C75.6252 21.2464 70.1645 22.5458 67.2321 23.2081C62.2439 24.3344 58.2202 25.2077 58.1699 25.2188C57.6945 25.324 56.3538 22.1994 57.2576 21.9996Z'
          fill='#CDE0DF'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M58.1463 25.2021C57.4987 25.3885 56.7694 24.8189 56.5174 23.93C56.2654 23.0411 56.5862 22.1694 57.2339 21.9831'
          fill='#CDE0DF'
        />
        <path
          d='M58.1463 25.2021C57.4987 25.3885 56.7694 24.8189 56.5174 23.93C56.2654 23.0411 56.5862 22.1694 57.2339 21.9831'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M62.8355 23.6208L70.7023 25.4821'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.13'
          d='M53.3164 24.49L56.5748 24.3324L78.2567 19.5367L78.6538 20.0119L79.295 20.3517L57.9782 25.2335L53.3164 24.49Z'
          fill='#FF5612'
        />
        <path
          d='M71.138 22.7521C70.7828 23.2687 70.1802 23.542 69.5715 23.4808L63.2186 21.9778C62.3179 21.7647 61.4162 22.3276 61.2047 23.2351C61.0431 23.928 61.3309 24.6216 61.877 25.0057C62.046 25.1244 62.2398 25.2138 62.4527 25.2641L67.5703 26.4749C68.1431 26.6104 68.6642 26.9114 69.0697 27.3409L71.9282 30.3692C72.9568 31.4589 74.1752 32.3493 75.5228 32.996L77.5601 33.9738L79.4491 31.247'
          fill='#FCD3B6'
        />
        <path
          d='M71.138 22.7521C70.7828 23.2687 70.1802 23.542 69.5715 23.4808L63.2186 21.9778C62.3179 21.7647 61.4162 22.3276 61.2047 23.2351C61.0431 23.928 61.3309 24.6216 61.877 25.0057C62.046 25.1244 62.2398 25.2138 62.4527 25.2641L67.5703 26.4749C68.1431 26.6104 68.6642 26.9114 69.0697 27.3409L71.9282 30.3692C72.9568 31.4589 74.1752 32.3493 75.5228 32.996L77.5601 33.9738L79.4491 31.247'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          opacity='0.83'
          d='M82.2487 28.2472L77.5601 33.9735L75.5228 32.996C74.1752 32.3491 72.9568 31.4589 71.9281 30.369L69.0696 27.3409C68.664 26.9109 68.1429 26.61 67.5701 26.475L62.4526 25.2639C62.2395 25.2136 62.0457 25.1242 61.8767 25.0054C61.3305 24.6214 61.0431 23.9281 61.2043 23.2348C61.3115 22.7765 61.5944 22.4059 61.9648 22.1795C61.4676 23.013 61.6529 24.1522 62.183 24.525C62.352 24.6437 62.5458 24.7331 62.7589 24.7835L69.1487 26.2684C69.7213 26.4038 70.2423 26.7047 70.6481 27.1342L72.7015 29.2525C73.7304 30.3419 74.9486 31.2325 76.2962 31.8794L76.9787 32.2196L82.2487 28.2472Z'
          fill='#EAAA96'
        />
        <path
          d='M77.8109 36.2805L76.1835 34.7504L82.2971 28.1504L83.3175 29.0893L77.8109 36.2805Z'
          fill='white'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M95 39.3725L95 53.434L76.7695 37.3403L76.6006 37.1914L78.2737 35.172L80.9907 31.8904L83.3108 29.0904L95 39.3725Z'
          fill='#FF5612'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M79.6561 20.2665C80.3037 20.0802 80.6245 19.2085 80.3725 18.3195C80.1206 17.4305 79.3912 16.8609 78.7435 17.0473C78.0958 17.2336 77.775 18.1053 78.027 18.9943C78.279 19.8833 79.0084 20.4529 79.6561 20.2665Z'
          fill='#B1C9C7'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M79.7103 19.6017C79.3073 19.7176 78.8536 19.3633 78.6967 18.8102C78.54 18.2571 78.7396 17.7148 79.1426 17.5989C79.5456 17.483 79.9993 17.8373 80.1561 18.3904C80.3129 18.9434 80.1133 19.4858 79.7103 19.6017Z'
          fill='#FFD671'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M79.197 17.5865L80.4753 17.2366L81.043 19.2394L79.7103 19.6017'
          fill='#FFD671'
        />
        <path
          d='M79.197 17.5865L80.4753 17.2366L81.043 19.2394L79.7103 19.6017'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M76.9592 19.726L76.9967 19.8681'
          stroke='#66321E'
          strokeWidth='0.2'
          strokeMiterlimit={10}
          strokeLinecap='round'
        />
        <path
          d='M81.043 19.2394C80.64 19.3553 80.1864 19.001 80.0296 18.4479C79.8729 17.8948 80.0725 17.3525 80.4755 17.2366C80.8785 17.1207 81.3322 17.475 81.489 18.0281C81.6457 18.5811 81.4461 19.1235 81.043 19.2394Z'
          fill='#FFD671'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M77.1217 19.9561C77.1217 19.9561 72.4294 21.0162 72.4867 21.0006Z'
          fill='#FFD671'
        />
        <path
          d='M77.1217 19.9561C77.1217 19.9561 72.4294 21.0162 72.4867 21.0006'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
        <path
          d='M72.2148 21.3966C72.0682 21.2936 72.0252 21.1273 72.0225 21.1159C71.9603 20.8617 72.1117 20.6039 72.3627 20.5358C72.375 20.5325 72.3873 20.5296 72.3995 20.5274C72.6016 20.4836 75.7885 19.7641 77.0173 19.4864C77.2747 19.4283 77.5301 19.5914 77.5879 19.8508C77.6456 20.1101 77.4837 20.3675 77.2262 20.4256C77.2262 20.4256 76.0675 20.6875 74.9086 20.9489C74.3291 21.0796 73.7496 21.2103 73.3149 21.3082C73.0974 21.3572 72.9161 21.3979 72.7892 21.4263L72.641 21.4594C72.4452 21.5029 72.3087 21.4628 72.2148 21.3966Z'
          fill='#FFD671'
          stroke='#FF5612'
          strokeWidth='0.2'
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id='clip0_25_262'>
          <rect width={95} height={61} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ForBrands;
